// components/DocumentCard.jsx
import React from 'react';

const DocumentCard = ({ doc }) => (
    <div className="flex items-center justify-between p-3 bg-[#F4F8E9] rounded-lg hover:bg-[#E8F0D9] transition-colors">
        <div className="flex items-center">
            {doc.icon}
            <div className="ml-3">
                <span className="font-medium text-[#437011]">{doc.type}</span>
                <p className="text-sm text-gray-500">Expire le {new Date(doc.expiration).toLocaleDateString()}</p>
            </div>
        </div>
        <span className={`px-2 py-1 rounded-full text-sm ${
            doc.status === 'Valide'
                ? 'bg-[#96B734] text-white'
                : 'bg-[#FF8A3D] text-white'
        }`}>
            {doc.status}
        </span>
    </div>
);

export default DocumentCard;